import { yup } from "@swa-ui/object";

export const ALLERGIES_SCHEMA_FIELD_NAMES = {
  PEANUT_ALLERGY: "passengerDisabilityPeanut",
};

export const getAllergiesFormFieldsSchema = (fieldNames = {}) => {
  const { PEANUT_ALLERGY } = ALLERGIES_SCHEMA_FIELD_NAMES;
  const { peanutAllergy = PEANUT_ALLERGY } = fieldNames;

  return {
    [peanutAllergy]: yup.boolean(),
  };
};
